import { all } from 'redux-saga/effects';
import adminSagas from './Containers/Admin/saga';
import appSaga from './Containers/App/saga';
import basicRegistrationSagas from './Containers/BasicRegistration/saga';
import billCreditSaga from './Containers/BillCredits/saga';
import billPaymentSaga from './Containers/Deliveries/saga';
import deliverySaga from './Containers/BillPayments/saga';
import loginSaga from './Containers/Login/saga';
import publicFilesSaga from './Containers/PublicFiles/saga';
import socialMediaSaga from './Containers/SocialMedia/saga';
import vendorApplicationSaga from './Containers/VendorApplication/saga';
import vendorBillsSaga from './Containers/VendorBills/saga';
import vendorAttributionSaga from './Containers/VendorAttribution/saga';
import userSaga from './Containers/User/saga';
import complianceSaga from './Containers/Compliance/saga';
import factorySaga from './Containers/Factory/saga';

export default function* rootSaga() {
  yield all([
    adminSagas(),
    appSaga(),
    basicRegistrationSagas(),
    billCreditSaga(),
    billPaymentSaga(),
    deliverySaga(),
    loginSaga(),
    publicFilesSaga(),
    vendorApplicationSaga(),
    vendorAttributionSaga(),
    vendorBillsSaga(),
    userSaga(),
    socialMediaSaga(),
    complianceSaga(),
    factorySaga(),
  ]);
}
